import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  EDIT_BUTTON: `${cleanedFilename(__filename)}-edit-button`,
  NAME: `${cleanedFilename(__filename)}-name`,
};
